<template>
  <div class="folder" :class="{ 'folder--hovered': hovered }">
    <img class="folder-flip" :src="flipImg" alt="" />

    <img class="folder-item folder-item--passport" :src="passportImg" alt="" />
    <img class="folder-item folder-item--suitcase" :src="suitcaseImg" alt="" />

    <div class="folder-card folder-card--1">
      <img :src="img1" alt="" />
    </div>
    <div class="folder-card folder-card--2">
      <img :src="img2" alt="" />
    </div>
    <div class="folder-card folder-card--3">
      <img :src="img3" alt="" />
    </div>

    <img class="folder-base" :src="baseImg" alt="" />

    <img class="sticker sticker--star" :src="starImg" alt="" />
    <img class="sticker sticker--facebook" :src="facebookImg" alt="" />
    <img class="sticker sticker--instagram" :src="instagramImg" alt="" />
    <img class="sticker sticker--gmail" :src="gmailImg" alt="" />
    <img class="sticker sticker--flag" :src="flagImg" alt="" />
  </div>
</template>

<script setup lang="ts">
import passportImg from 'app/assets/images/marketing/passport.png'
import suitcaseImg from 'app/assets/images/marketing/suitcase.png'
import flipImg from 'app/assets/images/marketing/flip.png'
import baseImg from 'app/assets/images/marketing/base.png'
import img1 from 'app/assets/images/marketing/img-1.png'
import img2 from 'app/assets/images/marketing/img-2.png'
import img3 from 'app/assets/images/marketing/img-3.png'
import starImg from 'app/assets/images/marketing/star-06.png'
import facebookImg from 'app/assets/images/marketing/facebook.png'
import instagramImg from 'app/assets/images/marketing/instagram.png'
import gmailImg from 'app/assets/images/marketing/gmail.png'
import flagImg from 'app/assets/images/marketing/flag-stamp.png'

defineProps<{ hovered?: boolean }>()
</script>

<style lang="scss" scoped>
.folder {
  position: relative;
  width: 184.29px;
  height: 134.44px;
}

// Back folder flap — behind everything
.folder-flip {
  position: absolute;
  width: 145px;
  right: 20px;
  left: 20px;
  top: -15px;
  z-index: 0;
}

// Passport and suitcase illustration stickers (behind cards)
.folder-item {
  position: absolute;
  display: block;
  z-index: 2;
  transition:
    left 0.35s ease,
    top 0.35s ease;

  &--passport {
    left: 35px;
    top: -60px;
    width: 150px;
    height: 150px;
    transform: rotate(5deg);
  }

  &--suitcase {
    left: -50px;
    top: -45px;
    width: 130px;
    height: 130px;
  }
}

// Photo cards
.folder-card {
  position: absolute;
  width: 95px;
  height: 95px;
  border-radius: 18px;
  z-index: 1;
  transition:
    left 0.35s ease,
    top 0.35s ease;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  &--1 {
    left: -24px;
    top: 10px;
    transform: rotate(-10deg);
  }

  &--2 {
    left: 30px;
    top: -45px;
  }

  &--3 {
    left: 105px;
    top: 2px;
    z-index: 3;
    transform: rotate(14deg);
  }
}

.folder-base {
  position: absolute;
  display: block;
  width: 184.29px;
  height: 134.44px;
  z-index: 4;
}

.sticker {
  position: absolute;
  display: block;
  z-index: 5;

  &--star {
    left: 30px;
    top: 10px;
    width: 45px;
    height: 45px;
    transform: rotate(18deg);
  }

  &--facebook {
    left: 80px;
    top: 55px;
    width: 24px;
    height: 24px;
  }

  &--instagram {
    left: 60px;
    top: 70px;
    width: 24px;
    height: 24px;
  }

  &--gmail {
    left: 85px;
    top: 78px;
    width: 24px;
    height: 24px;
  }

  &--flag {
    left: 115px;
    top: 30px;
    width: 45px;
    height: 38px;
  }
}

// Hover: cards and items fan out from folder
.folder:hover,
.folder--hovered {
  @include desktop {
    .folder-card {
      z-index: 3;
    }

    .folder-card--1 {
      left: -60px;
      top: 10px;
    }

    .folder-card--2 {
      left: 30px;
      top: -80px;
    }

    .folder-card--3 {
      left: 150px;
      top: -5px;
    }

    .folder-item--passport {
      left: 60px;
      top: -90px;
      z-index: 4;
    }

    .folder-item--suitcase {
      left: -75px;
      top: -80px;
      z-index: 4;
    }
  }
}
</style>
